import React from 'react';

import PhoneInput, { PhoneInputProps } from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const CanadaPhoneInput = (props: PhoneInputProps) => {
    return (
      <PhoneInput
        value={props.value}
        disabled={props.disabled}
        country='ca'
        onlyCountries={['ca']}
        placeholder='(xxx) xxx-xxxx'
        onChange={props.onChange}
        inputClass={props.inputClass}
        />
    )
}

export default CanadaPhoneInput
